export enum feedGroupsPaths {
  root = '/feed',
  groups = '/feed/groups',
  general = '/feed/groups/general',
  advanced = '/feed/groups/advanced',
  create = '/feed/groups/general/create',
  edit = '/feed/groups/general/edit',
  bunkReader = '/feed/groups/bunk-reader',
}
